import script from "./NutritionRate.vue?vue&type=script&setup=true&lang=js"
export * from "./NutritionRate.vue?vue&type=script&setup=true&lang=js"

import "./NutritionRate.vue?vue&type=style&index=0&id=f0498552&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0498552"]])

export default __exports__